// extracted by mini-css-extract-plugin
export default {"controlButton":"MH58Yn","hidden":"sMWGVV","container":"T7h78h","fillAllSpace":"aBdaFm","fullScreen":"reHOyF"};